module.exports = __webpack_public_path__ + "img/Dropdown-Arrow.b1eede12.svg";